export const getDefaultCardId = body => {
  const defaultCard = body.results.find(card => card.is_default);

  return defaultCard && defaultCard.id;
};



// WEBPACK FOOTER //
// ./src/modules/payment/model.js